module.exports = __webpack_public_path__ + "fonts/Artifakt-Element-Medium.b3301b94.woff";